import { jsx as o } from "react/jsx-runtime";
import { TabButtonLink as n, Button as u } from "./style.js";
function p({
  active: t,
  url: e,
  children: r,
  ...a
}) {
  return e ? /* @__PURE__ */ o(n, { role: "tab", url: e, replace: !0, "aria-selected": t, children: r }) : /* @__PURE__ */ o(u, { role: "tab", type: "button", "aria-selected": t, ...a, children: r });
}
export {
  p as TabButton
};
